import React, { useEffect, useMemo, useState } from "react";
import { Field, Formik, Form, ErrorMessage, useFormikContext } from "formik";
import { Link, useParams } from "react-router-dom";
import { useGlobalContext } from "../../hooks/Helper/GlobalContext";
import { NotificationBanner } from "../../components/NotificationBanner/NotificationBanner";
import { useTranslation } from "react-i18next";
import { useCountries } from "../../hooks/useCountries";
import { useStates } from "../../hooks/useStates";
import { useGetallOrganizationById } from "../../hooks/useGetallOrganization";
import { useOrganiaationMutation } from "../../hooks/useUpdateOrganization";
import { useOrganizationSchema } from "../../schemas/organization";
import { IValueOrganization, IValueUpdateOrganization, OrgManager } from "../../types/organization";
import { getContactId, OptionSet } from "../../tools/utils";
import { BlockUI, Loader } from "../../components/Loader";
import { useOrgType } from "../../hooks/useOrgType";
import { DebounceInput } from "react-debounce-input";
import classNames from "classnames";
import { useGetOrganization } from "../../hooks/useGetOrganization";
import { screenedValuesOrganization } from "../../tools/constants";
import { OrganizationInformation } from "./OrganizationInformation";

export const UpdateOrganization = ({
  headerMarginTop,
}: {
  headerMarginTop: number;
}) => {
  const { photoBannerVisible, PhotoBannerMessage } = useGlobalContext();
  const { t } = useTranslation();
  const { organizationId } = useParams();
  const contactId = getContactId();
  const countriesQuery = useCountries();
  const countriesData = countriesQuery.data?.data.Data || [];
   const orgtype =useOrgType();
   const orgtypeData = orgtype.data?.data.Data || [];
  const updateOrganization = useOrganiaationMutation();
  const { data: organizationData, isLoading:Organizationdata } =
    useGetOrganization(organizationId);

 const organizationSchema = useOrganizationSchema();
  const [initialValues, setInitialValues] = useState<IValueUpdateOrganization>({
  
    OrganizationId: "",
    Name: "",
    Address1: "",
    Address2: "",
    City: "",
    ZipCode: "",
    OtherType: "",
    CountryId: "",
    StateId: "",
    Type: " ",
    LegalName :'',
    WebsiteUrl :'',
     ExtraDetails :'',
     OrgManager: [
      { 
        Id: contactId,
        ManagerName:'',
        IsPrimary: true,
      },
    ],
  });

  useEffect(() => {
    if (organizationData?.Data) {
      setInitialValues({
        OrganizationId: organizationData.Data.OrganizationId,
        Name: organizationData.Data.Name,
        Address1: organizationData.Data.Address1,
        Address2: organizationData.Data.Address2,
        City: organizationData.Data.City,
        ZipCode: organizationData.Data.ZipCode,
        OtherType: organizationData.Data.OtherType || "",
        CountryId: organizationData.Data.CountryId,
        StateId: organizationData.Data.StateId,
        Type: organizationData.Data.Type,
        LegalName :organizationData.Data.LegalName,
        WebsiteUrl :organizationData.Data.WebsiteUrl, 
        ExtraDetails :organizationData.Data.ExtraDetails,
        OrgManager: [
          {
            Id: organizationData.Data.OrgManagers[0]?.Id || contactId,
           ManagerName : organizationData.Data.OrgManagers[0]?.ManagerName|| '',
            IsPrimary: true,
          },
        ],
      });
    }
    
  }, [organizationData]);


  const handleSubmit = async (
    values: IValueUpdateOrganization,
    { setSubmitting }
  ) => {
    try {
   
      await updateOrganization.mutateAsync(values);
      window.location.href = `/OrganizationInformation/${organizationId}`;
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  const States = () => {
    const { values } = useFormikContext<IValueUpdateOrganization>();
    const statesQuery = useStates(values.CountryId || undefined);
    const statesData = statesQuery.data?.data.Data || [];

    return (
      <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
        <label htmlFor="StateId">
          {t("account.personalForm.state")}{" "}
          <span style={{ color: "#db3a3a" }}>*</span>
        </label>
        {statesQuery.isLoading && <Loader scale={0.6} fieldset />}
        <Field
          as="select"
          name="StateId"
          id="StateId"
          disabled={statesQuery.isLoading || !values.CountryId}
        >
          <option value="">{t("account.personalForm.selectState")}</option>
          {statesData.map((state) => (
            <option key={state.ProvinceId} value={state.ProvinceId}>
              {state.ProvinceName}
            </option>
          ))}
        </Field>
        <ErrorMessage
          component="div"
          name="StateId"
          className="cco_form_message cco_form_message_error"
        />
      </li>
    );
  };

 const [isExpanded, setIsExpanded] = useState(true);

  return (
    <>
    <div id="main-content" style={{ marginTop: headerMarginTop }}>
      <div className="cco_content_area cco_content_area_0">
        <article className="react-container">
          <NotificationBanner
            background="red"
            showBanner={photoBannerVisible}
            message={PhotoBannerMessage}
            color="white"
          />
         
                                       <div className="cco_section cco_section_0">
            <div className="cco_row cco_row_8">
              <div className="cco_col">
                <div className="cco_text cco_text_11">
                  <div className="cco_text_inner">
                    <strong>
                      <Link to={`/OrganizationInformation/${organizationId}`}>  {t("MyCCOPro.OrganizationDetails.information")}</Link>
                    </strong>{" "}
                    {" > "}  {t('MyCCOPro.CreateOrg.update')}
                  </div>
                </div>
              </div>
            </div>
            { Organizationdata ? (
                                             <div className="cco_form_wrap">
                                                 <Loader />
                                             </div>
                                         
                                         ) : ( 
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={organizationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, isSubmitting }) => (
                <Form
                  className="cco_form"
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                >
                  <ul className="cco_form_fieldset">
                    <Field type="hidden" name="OrganizationId" />
                    <Field type="hidden" name="CandidateManagerId" />
        <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                  <label htmlFor="ccoOrganizationName">
                                    {t('MyCCOPro.CreateOrg.displayName')}{" "}
                                    <span style={{ color: "#db3a3a" }}>*</span>
                                  </label>
                                  <Field  disabled type="text" id="Name" name="Name" />
                                  <ErrorMessage
                                    name={"Name"}
                                    component={"div"}
                                    className="cco_form_message cco_form_message_error"
                                  />
                                </li>
                                <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
  <label htmlFor="Type">
{t('MyCCOPro.CreateOrg.orgType')}{" "}
    <span style={{ color: "#db3a3a" }}>*</span>
  </label>
  {orgtype.isLoading && <Loader scale={0.6} fieldset={true} />}
  <Field
  disabled
    as="select"
    id="Type"
    name="Type"
    
  >
    <option value="">
         {orgtype.isLoading
  ? t('MyCCOPro.CreateOrg.loading')
  : t('MyCCOPro.CreateOrg.selectType')}
    </option>
    {orgtypeData.map((orgType) => (
                                      <option
                                        key={orgType.Id}
                                        value={orgType.Id}
                                      >
                                        {orgType.Name}
                                      </option>
                                    ))}
  </Field>
  <ErrorMessage
    name="Type"
    component="div"
    className="cco_form_message cco_form_message_error"
  />
</li>

                           

                                {/* Conditionally Render "Other Type" Field */}
                                {values.Type === "Other" && (
                                  <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                    <label htmlFor="ccoOtherType">
                                      {t('MyCCOPro.CreateOrg.otherType')}{" "}
                                      <span style={{ color: "#db3a3a" }}>
                                        *
                                      </span>
                                    </label>
                                    <Field
                                      type="text"
                                      id="ccoOtherType"
                                      name="OtherType"
                                      required
                                    />
                                    <ErrorMessage
                                      name="OtherType"
                                      component="div"
                                      className="cco_form_message cco_form_message_error"
                                    />
                                  </li>
                                )}
                        <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                                    <label htmlFor="ccoOrganizationlegalName">
                                                      {t('MyCCOPro.CreateOrg.legalName')}{" "}
                                                      <span style={{ color: "#db3a3a" }}>*</span>
                                                    </label>
                                                    <Field disabled type="text" id="LegalName" name="LegalName" />
                                                    <ErrorMessage
                                                      name={"LegalName"}
                                                      component={"div"}
                                                      className="cco_form_message cco_form_message_error"

                                                    />
                                                  </li>
                                                  <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                                                    <label htmlFor="ccoOrganizationWebsite">
                                                     {t('MyCCOPro.CreateOrg.website')}{" "}
                                                      <span style={{ color: "#db3a3a" }}>*</span>
                                                    </label>
                                                    <Field type="text" id="WebsiteUrl" name="WebsiteUrl" />
                                                    <ErrorMessage
                                                      name={"WebsiteUrl"}
                                                      component={"div"}
                                                      className="cco_form_message cco_form_message_error"
                                                    />
                                                  </li>
                    <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                      <label htmlFor="Address1">  {t('MyCCOPro.CreateOrg.street1')} *</label>
                      <Field type="text" id="Address1" name="Address1" />
                      <ErrorMessage
                        name="Address1"
                        component="div"
                        className="cco_form_message cco_form_message_error"
                      />
                    </li>

                    <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                      <label htmlFor="Address2">{t('MyCCOPro.CreateOrg.street2')} </label>
                      <Field type="text" id="Address2" name="Address2" />
                      <ErrorMessage
                        name="Address2"
                        component="div"
                        className="cco_form_message cco_form_message_error"
                      />
                    </li>

                    <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                      <label htmlFor="CountryId">
                        {t("account.personalForm.country")} *
                      </label>
                      {countriesQuery.isLoading && (
                        <Loader scale={0.6} fieldset />
                      )}
                      <Field as="select" id="CountryId" name="CountryId">
                        <option value="">
                          {t("account.personalForm.selectaCountry")}
                        </option>
                        {countriesData.map((country) => (
                          <option
                            key={country.CountryId}
                            value={country.CountryId}
                          >
                            {country.CountryName}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="CountryId"
                        component="div"
                        className="cco_form_message cco_form_message_error"
                      />
                    </li>

                    <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                      <label htmlFor="City">     {t('MyCCOPro.CreateOrg.city')} *</label>
                      <Field type="text" id="City" name="City" />
                      <ErrorMessage
                        name="City"
                        component="div"
                        className="cco_form_message cco_form_message_error"
                      />
                    </li>

                    <States />

                    <li className="cco_form_fieldset_item cco_form_fieldset_item_small">
                      <label htmlFor="ZipCode"> {t('MyCCOPro.CreateOrg.zipCode')}*</label>
                      <Field type="text" id="ZipCode" name="ZipCode" />
                      <ErrorMessage
                        name="ZipCode"
                        component="div"
                        className="cco_form_message cco_form_message_error"
                      />
                    </li>

                
                                                    <li className="cco_form_fieldset_item">
                      <label htmlFor="AdditionalDetails">
                        {t('MyCCOPro.CreateOrg.extraDetails')}
                      </label>
                      <Field
                      disabled 
                        as="textarea"
                        id="ExtraDetails"
                        name="ExtraDetails"
                        rows={4}
                        className="cco_form_textarea"
                       
                      />
                   
                    </li>
                  </ul>
                  <button
                    type="submit"
                    className="cco_btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ?  t('MyCCOPro.CreateOrg.saving') : t('MyCCOPro.CreateOrg.update')}
                  </button>
                </Form>
              )}
            </Formik>
                 )}

          </div>
                                    
        </article>
        
      </div>
    </div>
<BlockUI
        title={
          "Please wait while your organization is being updated. Do not refresh the page or click the back button."
        }
        blocking={updateOrganization.isLoading || updateOrganization.isSuccess}
      />
</>
  );
};

